// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"1217523eaaa4c285","4553":"b39dbd97004bc4b5","4939":"dc90bad984c6897c"}[chunkId] + ".css";
};